module.exports = __webpack_public_path__ + "static/media/before1.36c2a115.jpg";